export const breadcrumb = {
  title: 'Predictive Dialer',

  campaign: {
    index: 'Campaigns',
    edit: 'Edit Campaign',
    new: 'Add Campaign'
  },

  operators: {
    index: 'Operators',
    edit: 'Edit Operators',
    new: 'Add Operators'
  },

  webhook: {
    index: 'Webhooks',
    edit: 'Edit Campaign',
    new: 'Add Campaign'
  },

    
  settings: {
    index: 'Settings'
  },
  
  products: {
    index: 'Products'
  },

  monitoring: {
    index: 'Monitoring {name}'
  },

  monitoring_general: {
    index: 'Monitoring {name}'
  },

  task: {
    index: 'Tasks',
    edit: 'Edit task',
    new: 'Create task'
  }
};
